import { Injectable } from "@angular/core";
import { ISharedResource } from "@common/interfaces/sharedResource";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { BaseEntityStoreStrategy } from "../updateStoreStrategies";
import { SharedResourceQuery } from './sharedResource.query';
import { SharedResourceStore } from './sharedResource.store';

@Injectable({
  providedIn: 'root'
})
export class SharedResourceService extends CrudService<ISharedResource, SharedResourceStore, SharedResourceQuery> {
  constructor(
    protected store: SharedResourceStore,
    public query: SharedResourceQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(Topics.SHARED_RESOURCES, store, query, actionService, updateStrategy);
  }

}
